import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "profile-page__tab-content" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = {
  key: 0,
  class: "profile-page__subscriptions__list"
}
const _hoisted_4 = ["textContent"]


const __default__ = {
  name: 'SubscriptionsTab',
}
import { onMounted, ref } from 'vue'
import ListSkeleton from '../../skeletons/ListSkeleton.vue'
import AppContentWrapper from '../../global/AppContentWrapper.vue'
import SubscriptionItem from './subscriptions/SubscriptionItem.vue'
import Subscription from '../../../../../global/js/magento-api-library/types/Subscription'
import { getSubscriptions } from '../../../../../global/js/magento-api-library/subscriptions/getSubscriptions'
import { getIssueUrlBySku } from '../../../../../global/js/utils/getIssueUrlBySku'
import { log } from '../../../../../global/js/utils/logging'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const subscriptions = ref<Subscription[]>([])
const issueUrl = ref<string>('')

const hasLoaded = ref<boolean>(false)
const hasErrors = ref<boolean>(false)

const getIssueUrlIfExist = () => {
  try {
    if (subscriptions.value.length) {
      subscriptions.value.forEach(async (subscription, index, array) => {
        const sku = subscription.quote.items[0]?.sku
        const result = await getIssueUrlBySku(sku)

        issueUrl.value = result ?? '#'
        index++

        if (index == array.length) {
          hasLoaded.value = true
        }
      })
    }
  } catch (error) {
    log(error as string, 'src/reliasmedia/js/components/account/tabs/SubscriptionsTab.vue')
  }
}

onMounted(async (): Promise<void> => {
  try {
    const results = await getSubscriptions()

    if (results) {
      //getSubscriptions.ts should be populating a list of filtered subscriptions based on expiration date
      subscriptions.value = results

      getIssueUrlIfExist()
    }
    hasLoaded.value = true

  } catch (error) {
    hasLoaded.value = true
    hasErrors.value = true
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", {
      class: "profile-page__section-header",
      textContent: _toDisplayString('Subscriptions')
    }, null, 8, _hoisted_2),
    _createVNode(AppContentWrapper, {
      "has-loaded": hasLoaded.value,
      "has-errors": hasErrors.value,
      "error-text": "An error occurred and your subscriptions could not be retrieved."
    }, {
      loading: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
          return _createVNode(ListSkeleton, {
            key: `list-skeleton-${index}`,
            count: 3
          })
        }), 64))
      ]),
      loadedContent: _withCtx(() => [
        (subscriptions.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subscriptions.value, (subscription) => {
                return (_openBlock(), _createBlock(SubscriptionItem, {
                  key: subscription.entity_id,
                  subscription: subscription,
                  "issue-url": issueUrl.value
                }, null, 8, ["subscription", "issue-url"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("p", {
              key: 1,
              textContent: _toDisplayString(`You don't have any subscriptions.`)
            }, null, 8, _hoisted_4))
      ]),
      _: 1
    }, 8, ["has-loaded", "has-errors"])
  ]))
}
}

})